import { siteInfo } from '@/mocks/homeData';

const footerLinks = [
  {
    group: '快速导航',
    items: [
      { label: '焦点专题', href: '#carousel' },
      { label: '热度榜单', href: '#ranking' },
      { label: '视频爆料', href: '#media' },
      { label: '话题广场', href: '#topics' },
      { label: '常见问答', href: '#faq' },
    ],
  },
  {
    group: '关于我们',
    items: [
      { label: '平台介绍', href: '#about' },
      { label: 'APP下载', href: '#app' },
      { label: '投稿爆料', href: '#contact' },
      { label: '主题索引', href: '#index' },
    ],
  },
  {
    group: '合作伙伴',
    items: [],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                {siteInfo.name}
              </span>
              <p className="mt-4 text-sm leading-relaxed text-background-400">
                专注网红圈内幕八卦的吃瓜平台。7×24 小时追踪网红最新动态，做最靠谱的网红吃瓜入口。每日爆料，吃得明白。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.group}>
                <h4 className="text-sm font-heading font-semibold text-background-100 mb-4">
                  {group.group}
                </h4>
                {group.items.length > 0 ? (
                  <ul className="space-y-2.5">
                    {group.items.map((item) => (
                      <li key={item.label}>
                        <a
                          href={item.href}
                          className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                        >
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-sm text-background-500 italic">敬请期待</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} {siteInfo.name}. 本站内容仅供信息参考，不构成任何建议。
            </p>
            <p className="text-xs text-background-500">
              网红吃瓜吃料网每日爆料入口 · 网红吃料黑料爆料合集 · 网红内幕八卦最新吃瓜
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}